// extracted by mini-css-extract-plugin
export var attachButton = "_cm-8";
export var sendButton = "_cm-2";
export var sendDisabled = "_cm-4";
export var sendEnabled = "_cm-3";
export var sendIcon = "_cm-6";
export var sendIconDisabled = "_cm-7";
export var sendStreaming = "_cm-5";
export var textarea = "_cm-1";
export var wrapper = "_cm-0";